module.exports = __webpack_public_path__ + "static/media/healthcare_rcm.878ca218.png";